import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductForOrderQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  propertyIds?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetProductForOrderQuery = { __typename?: 'query_root', products_by_pk?: { __typename?: 'products', id: any, name: string, make: string, model: string, sku?: string | null, description: string, retail_price?: any | null, extended_price?: any | null, created_at?: any | null, organization_id?: any | null, workspace_id?: any | null, photo_link?: string | null, parent_product_id?: any | null, partition_id?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string, partition_id?: string | null } | null, shop_products: Array<{ __typename?: 'shop_products', id: any, product_id: any, property_id: any, created_at: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, partition_id?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, display_price?: boolean | null, type?: string | null } | null } | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null }> } | null };


export const GetProductForOrderDocument = gql`
    query GetProductForOrder($id: uuid!, $propertyIds: [uuid!]) {
  products_by_pk(id: $id) {
    id
    name
    make
    model
    product_category {
      name
      label
    }
    sku
    description
    retail_price
    extended_price
    created_at
    organization_id
    workspace_id
    photo_link
    parent_product_id
    partition_id
    parent_product {
      id
      name
      make
      model
      description
      partition_id
    }
    shop_products(where: {property_id: {_in: $propertyIds}}) {
      id
      product_id
      property_id
      created_at
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        partition_id
        organization {
          id
          name
          display_price
          type
        }
      }
    }
    product_attachments(order_by: {created_at: asc}) {
      id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      description
      name
    }
  }
}
    `;

/**
 * __useGetProductForOrderQuery__
 *
 * To run a query within a React component, call `useGetProductForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductForOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetProductForOrderQuery(baseOptions: Apollo.QueryHookOptions<GetProductForOrderQuery, GetProductForOrderQueryVariables> & ({ variables: GetProductForOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductForOrderQuery, GetProductForOrderQueryVariables>(GetProductForOrderDocument, options);
      }
export function useGetProductForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductForOrderQuery, GetProductForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductForOrderQuery, GetProductForOrderQueryVariables>(GetProductForOrderDocument, options);
        }
export function useGetProductForOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductForOrderQuery, GetProductForOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductForOrderQuery, GetProductForOrderQueryVariables>(GetProductForOrderDocument, options);
        }
export type GetProductForOrderQueryHookResult = ReturnType<typeof useGetProductForOrderQuery>;
export type GetProductForOrderLazyQueryHookResult = ReturnType<typeof useGetProductForOrderLazyQuery>;
export type GetProductForOrderSuspenseQueryHookResult = ReturnType<typeof useGetProductForOrderSuspenseQuery>;
export type GetProductForOrderQueryResult = Apollo.QueryResult<GetProductForOrderQuery, GetProductForOrderQueryVariables>;